import React from "react";
const TikTokIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M11.887 1.67c.235 2.08 1.363 3.32 3.324 3.451V7.46c-1.137.114-2.132-.268-3.29-.99v4.375c0 5.556-5.886 7.293-8.253 3.31-1.52-2.563-.59-7.06 4.289-7.24V9.38c-.372.061-.769.158-1.132.286-1.085.378-1.7 1.085-1.53 2.334.33 2.391 4.593 3.099 4.238-1.574V1.675h2.354V1.67z"
  }
));
var TikTokIcon_default = TikTokIcon;
export {
  TikTokIcon_default as default
};
//# sourceMappingURL=TikTokIcon.js.map
